import { useServiceContainer } from "@/services/serviceContainer";

export const useServices = () => useServiceContainer().services;
export const useServiceAdapters = () => useServiceContainer().adapters;
export const useServiceProviders = () => useServiceContainer().providers;
